<template>
  <div>
    <el-table
            :data="list"
            style="width: 100%">
      <el-table-column
              prop="task_sn"
              label="订单编号"
              width="170">
      </el-table-column>
      <el-table-column
              prop="create_time"
              label="创建时间"
              width="140">
      </el-table-column>
      <el-table-column
              prop="type_name"
              label="推广类型"
              width="80">
      </el-table-column>
      <el-table-column
              prop="reward_type"
              label="奖励类型"
              width="110">
              <template slot-scope="scope">
                <span v-if="scope.row.reward_type == '0'">赏金</span>
                <span v-if="scope.row.reward_type == '1'">优惠券</span>
                <span v-if="scope.row.reward_type == '2'">体验</span>
                <span v-if="scope.row.reward_type == '3'">实物</span>
                <span v-if="scope.row.reward_type == '4'">抽奖次数</span>
              </template>
      </el-table-column>
      <el-table-column
              prop="task_price"
              label="推广金额"
              width="80">
      </el-table-column>
      <el-table-column
              prop="task_title"
              label="推广标题">
      </el-table-column>
      <el-table-column
              fixed="right"
              label="操作"
              width="210">
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row.id,scope.row.type)" size="small">再次发布</el-button>
          <el-button @click="handleClick(scope.row.id)" size="small">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages">
      <el-pagination
              @current-change="current_change"
              :current-page.sync="page"
              :page-size="10"
              layout="prev, pager, next, jumper"
              :total="orderTotal"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Tab1',
    inject:['getOrder'],
    props: {
      list: Array,
      orderTotal: Number,
      currentPage:Number
    },
    data(){
      return{
        page:this.currentPage
      }
    },
    methods: {
      current_change (currentPage) {
        this.currentPage = currentPage;
        this.$emit('changcurrent',currentPage);
        // 调用父组件方法
        this.getOrder();
      },
      handleClick (id,) {
        this.$router.push({path:'/enterprise/detail'+'?id='+id})
      },
      handleEdit (id,type) {
          if (type == 1) {
              this.$router.push({path:'/enterprise/again'+'?id='+id + '&type=' + type})
          } else if (type == 0 ) {
              this.$alert('该任务是在小程序端发布的，请前往小程序端编辑', '提示', {
                  confirmButtonText: '确定'
              });
          }

      }
    }
  }
</script>
<style scoped></style>
